import { faArrowUpRight } from '@fortawesome/pro-light-svg-icons/faArrowUpRight'
import Button from '@hotmart/space-lib/dist/components/button'
import Icon from '../../Icon'
import Modal from '../index'
import ModalHeader from '../header'
import ModalBody from '../body'
import ModalFooter from '../footer'
import { IMAGES } from '../../../assets'
import i18n from '../../../i18n'
import { useUser } from '../../../hook/useUser'
import { treatLanguage } from '../../../utils/functions'
import { ButtonContainer, HeaderImage } from './styles'
import { NoAccessProps } from './noAccess.types'

const NoAccess = ({ isOpen, closeModal }: NoAccessProps) => {
  const { locale, slug } = useUser()
  const treatedLocale = treatLanguage(locale)

  const handleRedirectToProducts = () => {
    window.location.pathname = `/${treatedLocale}/club/${slug}/products`
  }

  return (
    <Modal show={isOpen} onClose={closeModal}>
      <ModalHeader className="_pt-5" />
      <ModalBody>
        <HeaderImage>
          <img src={IMAGES.NO_ACCESS} alt="no_access" />
          <p className="_text-4 _text-gray-700 _my-5 _text-center">
            {i18n.t('modal_no_access_community.title')}
          </p>
        </HeaderImage>
        <p className="_text-2 _text-gray-500 _text-center">
          {i18n.t('modal_no_access_community.description')}
        </p>
      </ModalBody>
      <ModalFooter>
        <ButtonContainer className="_d-flex _w-full _justify-content-end _align-items-center">
          <Button variation="tertiary" onClick={closeModal}>
            {i18n.t('modal_no_access_community.button_close')}
          </Button>
          <Button variation="primary" onClick={handleRedirectToProducts}>
            <span className="_pr-1">
              {i18n.t('modal_no_access_community.button_show_products')}{' '}
            </span>
            <Icon height={15} icon={faArrowUpRight} />
          </Button>
        </ButtonContainer>
      </ModalFooter>
    </Modal>
  )
}

export default NoAccess
